import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=b191586a&scoped=true&"
import script from "./user-dropdown.vue?vue&type=script&lang=js&"
export * from "./user-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&id=b191586a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b191586a",
  null
  
)

export default component.exports